import styled from 'styled-components';

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  .error {
    color: ${({ theme }) => theme.danger_500};
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;

  .text {
    max-width: 300px;
  }
`;
